import React from 'react';

import {
  CardContent,
  CardRow,
  HotelTitle,
  HotelSubtitle,
  CardFooter,
  CardFooterPrice,
  CardFooterFullPrice,
} from 'components/Cards/DataCardHotels/styles';
import Shimmer from 'components/Shimmer';
import withGrid from 'hocs/withGrid';

import { Card, CardHeader } from './styles';

const LoadingCard = () => (
  <Card>
    <CardHeader></CardHeader>
    <CardContent>
      <CardRow>
        <HotelTitle>
          <Shimmer>Hotel name</Shimmer>
        </HotelTitle>
      </CardRow>
      <CardRow>
        <HotelSubtitle>
          <Shimmer>City name</Shimmer>
        </HotelSubtitle>
      </CardRow>
    </CardContent>
    <CardFooter>
      <CardFooterPrice>
        <Shimmer>$99.999 COP/noche</Shimmer>
      </CardFooterPrice>
      <CardFooterFullPrice>
        <Shimmer>$999.999 COP</Shimmer>
      </CardFooterFullPrice>
    </CardFooter>
  </Card>
);

export default withGrid(LoadingCard);
